import React, { useContext, useState } from "react";
import classes from "./EditBoard.module.scss";
import Modal from "../Modal/Modal";
import { ModalContext } from "../../store/modal-context";
import { BoardContext } from "../../store/board-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

const EditBoard = () => {
  const { modalPayload, closeModal } = useContext(ModalContext);
  const { boards, editBoard } = useContext(BoardContext);
  const { boardId } = modalPayload;

  const board = boards.find((b) => b.id === boardId);

  const [title, setTitle] = useState(board?.title || "");
  const [columnNames, setColumnNames] = useState(
    board?.columns.map((col) => col.name) || []
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!board) return null;

  const handleColumnChange = (index, value) => {
    setColumnNames((prev) => prev.map((name, i) => (i === index ? value : name)));
  };

  const handleAddColumn = (e) => {
    e.preventDefault();
    setColumnNames((prev) => [...prev, ""]);
  };

  const handleRemoveColumn = (index) => {
    setColumnNames((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const trimmedTitle = title.trim();
    if (!trimmedTitle) {
      alert("Please enter a board name.");
      return;
    }
    setIsSubmitting(true);
    await editBoard(boardId, trimmedTitle, columnNames.map((name) => name.trim()));
    setIsSubmitting(false);
    closeModal();
  };

  return (
    <Modal>
      <form className={`${classes.edit_board}`} onSubmit={handleSave}>
        <h3>Edit Board</h3>
        <section className={`${classes.board_name}`}>
          <label htmlFor="edit-board-name">Board Name</label>
          <input
            id="edit-board-name"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </section>
        <section className={`${classes.board_columns}`}>
          <p>Board Columns</p>
          <section className={classes.board_column_names}>
            {columnNames.map((name, index) => (
              <div key={index}>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => handleColumnChange(index, e.target.value)}
                />
                <button
                  type="button"
                  aria-label={`Remove column ${name || index + 1}`}
                  className={classes.xMarkButton}
                  onClick={() => handleRemoveColumn(index)}
                >
                  <FontAwesomeIcon icon={faX} className={classes.xMark} aria-hidden="true" />
                </button>
              </div>
            ))}
          </section>
          <button
            className={`${classes.add_new_column}`}
            onClick={handleAddColumn}
            disabled={isSubmitting}
          >
            +add new column
          </button>
          <button className={classes.save_changes} type="submit" disabled={isSubmitting}>
            {isSubmitting ? "saving…" : "save changes"}
          </button>
        </section>
      </form>
    </Modal>
  );
};

export default EditBoard;
